import { useMemo } from "react";

import { useDeveloperHasPermission } from "@services/useDeveloperHasPermission";

import { hasDatasharesPermissions } from "./hasDatasharesPermissions";

export const useDatasharesPermissions = (): ReturnType<typeof hasDatasharesPermissions> => {
  const hasPermission = useDeveloperHasPermission();

  return useMemo(() => hasDatasharesPermissions({ hasPermission }), [hasPermission]);
};
